import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

/**
 *  Проекты с которых будут поступать заявки
*/
export const CRUDProjects = CRUDFactory('projects');

export default {
  ai(id, params) {
    return apiService.get(`/projects/${id}/ai`, params);
  },

  aiProgress(id, params) {
    return apiService.get(`/projects/${id}/ai/progress`, params);
  },

  saveAi(id, params) {
    return apiService.post(`/projects/${id}/ai`, params);
  },

  rag(projectId, clientQuestionId) {
    return apiService.get(`/projects/${projectId}/knowledge/rag/${clientQuestionId}`);
  },

  normalizeKnowledge(projectId, clientQuestionId, params = {}) {
    return apiService.post(`/projects/${projectId}/knowledge/normalize/${clientQuestionId}`, params);
  },

  saveKnowledge(projectId, clientQuestionId, params) {
    return apiService.post(`/projects/${projectId}/knowledge/save/${clientQuestionId}`, params);
  },

  deleteKnowledgeFile(projectId, fileId) {
    return apiService.delete(`/projects/${projectId}/knowledge/delete/${fileId}`);
  },

  projectQuestionCategories(id, params) {
    return apiService.get(`/projects/${id}/question-categories`, params);
  },

  attachUser(id, params) {
    return apiService.post(`/projects/${id}/attach-user`, params);
  },

  detachUser(id, params) {
    return apiService.post(`/projects/${id}/detach-user`, params);
  },

  attachCategory(id, params) {
    return apiService.post(`/projects/${id}/attach-category`, params);
  },

  detachCategory(id, params) {
    return apiService.post(`/projects/${id}/detach-category`, params);
  },
};
